import * as React from 'react';
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks';
import { BulletList, Icon, tk, Typography } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';
import { useCMSPageField } from '@/cms/fields';

export function CheckoutUsps() {
  const sid = useCheckoutSid();
  const items = useCMSPageField('Checkout.usps')?.items ?? [];

  if (!sid) {
    return null;
  }

  return (
    <>
      {items?.map(({ componentId }) => {
        return <CheckoutUspItems key={componentId} componentId={componentId} />;
      })}

      {(!items || items.length === 0) && (
        <>
          <CheckoutUspItems componentId="04d8fce1-36ed-467e-86f2-64e5fe896112" /> {/*ACPT NL SUMMER VARIANT*/}
          <CheckoutUspItems componentId="871bc718-3e73-4e2c-8a08-f5f519d22eb5" /> {/*PROD NL SUMMER VARIANT*/}
          <CheckoutUspItems componentId="de2d2dc8-5105-4263-9510-706977806660" /> {/*ACPT NL WINTER DEFAULT*/}
          <CheckoutUspItems componentId="8c693a9c-eb93-42c2-b603-179735526be6" /> {/*ACPT NL WINTER VARIANT*/}
          <CheckoutUspItems componentId="523bb173-fc69-41fc-a818-c0ecb59dc71f" /> {/*PROD NL WINTER DEFAULT*/}
          <CheckoutUspItems componentId="c51c53ef-79b6-42da-bc95-e2f537d70a0e" /> {/*PROD NL WINTER VARIANT*/}
        </>
      )}
    </>
  );
}

export function CheckoutUspItems(props: { componentId: string }) {
  const { componentId } = props;
  const { data, isLoading } = useCheckoutUsps(componentId);
  const { isDesktopSm } = useBreakpoints();
  if (isLoading) return '';
  if (!data) return '';

  return (
    <Wrapper $type={isDesktopSm ? 'inline' : 'vertical'}>
      {data?.usps.map((item) => (
        <CheckoutUsp key={item.text} $icon={item.icon ?? 'IconCheckmark'}>
          <Typography $variant="label" dangerouslySetInnerHTML={{ __html: item.text }} />
        </CheckoutUsp>
      ))}
    </Wrapper>
  );
}
const Wrapper = styled(BulletList.Root)`
  align-content: center;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
`;

const CheckoutUsp = styled(BulletList.Item)`
  ${Icon} {
    color: ${tk('color_palette_green_500')};
  }
`;
